'use client';

// Slower opacity+scale breath on a moss-colored dot replaces the louder
// gold status-pulse alert. Reads as a heartbeat, not a notification. Moss
// is reserved for "live / available" states per the new palette plan;
// gold stays reserved for the one primary CTA per viewport.
export function AvailabilityPill() {
  return (
    <div
      data-availability-pill
      className="availability-pill inline-flex items-center gap-2 rounded-full px-4 py-1.5"
      style={{
        animation: 'fade-down 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.3s both',
      }}
    >
      <span
        aria-hidden
        className="block rounded-full"
        style={{
          width: 6,
          height: 6,
          background: 'var(--moss)',
          animation: 'availability-breath 2.4s ease-in-out infinite',
        }}
      />
      <span
        className="availability-pill-text font-mono"
        style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em' }}
      >
        OPEN TO FULL-TIME ROLES
      </span>
    </div>
  );
}
